import api from "./Api";

class AjudaCategoriaService {
  GetAjudaCategoria(payload) {
    return api.get("/v1/ajudaCategoria/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAjudaCategoria(payload) {
    return api.post("/v1/ajudaCategoria/", payload).then((response) => {
      return response.data;
    });
  }

  PutAjudaCategoria(payload) {
    return api.put("/v1/ajudaCategoria/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAjudaCategoria(payload) {
    return api.delete("/v1/ajudaCategoria/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAjudaCategoriaOData(payload) {
    return api.get("/OData/AjudaCategoria" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AjudaCategoriaService();
